import get from 'lodash/get';

const specificUrl = [
  { regx: /\/project\/.+\/photos$/, className: 'project-photos-page' },
  // TODO: investigate row below
  { regx: /\/project-details\/[\d\w]+$/, className: 'project-details-page' },

];

export default (location) => {
  const pathname = get(location, 'pathname', '/main');
  const specificClass = specificUrl.find(({ regx }) => regx.test(pathname));

  if (specificClass) {
    return specificClass.className;
  }

  return `${pathname.substr(1).replace('/', '-')}-page`;
};
